import { SiteCustomization } from "../types/types";
import { SiteCustomizations } from "./constants";

export default function siteCustomization(
    customName: string,
    defaultValue: string,
    customizations: Array<SiteCustomization>,
    useValuesReplaced: boolean = false
): string {
    let output = defaultValue;
    if (customizations != null) {
        let customValue = customizations.filter(x => x.Name == customName);

        if (customValue.length > 0) {
            const valueToUse = useValuesReplaced ? customValue[0].ValuesReplaced : customValue[0].Value;
            if (valueToUse != "") {
                output = valueToUse;
            }
        }
    }
    return output;
}


export function getSupportEmailAddress(customizations: Array<SiteCustomization>): string {
    return siteCustomization(SiteCustomizations.SupportEmail, "audiences@experian.com", customizations);
}
